import { IAnswerable } from '../../../shared/models/answerable/Answerable.interface';

export interface IAnswerableState {
    answerables: IAnswerable[];
}

export const initialAnswerableState: IAnswerableState = {
    answerables: [],
};
